import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import {
    sortDirectionLabel,
    type NotificationCardSort,
    type NotificationCardSortKey
} from './notificationCardSort';

const OPTIONS: ReadonlyArray<{ key: NotificationCardSortKey; label: string }> = [
    { key: 'date', label: 'Date' },
    { key: 'level', label: 'Level' }
];

interface NotificationSortControlProps {
    sort: NotificationCardSort;
    onSelect: (key: NotificationCardSortKey) => void;
}

// Clicking the active option flips its direction, like a DataTable sort header.
export function NotificationSortControl({ sort, onSelect }: NotificationSortControlProps) {
    return (
        <div
            role="group"
            aria-label="Sort notifications"
            className="flex h-7 items-center gap-0.5 rounded-lg bg-gray-100 p-0.5"
        >
            {OPTIONS.map(({ key, label }) => {
                const active = sort.key === key;
                const ArrowIcon = sort.order === 'asc' ? ChevronUpIcon : ChevronDownIcon;
                const direction = sortDirectionLabel(key, active ? sort.order : 'desc');
                return (
                    <button
                        key={key}
                        type="button"
                        aria-pressed={active}
                        aria-label={`Sort by ${label.toLowerCase()}, ${direction}`}
                        onClick={() => onSelect(key)}
                        className={`flex h-full items-center gap-0.5 whitespace-nowrap rounded-md px-2 text-[11px] transition-colors ${
                            active
                                ? 'bg-white font-semibold text-gray-900 shadow-sm'
                                : 'font-medium text-gray-500 hover:text-gray-700'
                        }`}
                    >
                        {label}
                        {active && (
                            <ArrowIcon aria-hidden="true" className="h-3 w-3 text-gray-800" />
                        )}
                    </button>
                );
            })}
        </div>
    );
}
